import { useTheme, useMediaQuery } from '@mui/material';
import { useMemo } from 'react';

export const useDeviceType = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Small screen size
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // Between small and medium
  const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // above medium

  const deviceViewportSize = useMemo(() => {
    if (isMobile) {
      return 'sm';
    }
    if (isTablet) {
      return 'md';
    }
    return 'lg';
  }, [isMobile, isTablet]);

  return {
    isMobile,
    isTablet,
    isDesktop,
    deviceViewportSize,
  };
};
